query liabilitySpecialMarkets(
  $first: Int
  $offset: Int
  $condition: SpecialsLiabilityCondition
  $filter: SpecialsLiabilityFilter
) {
  allSpecialsLiabilities(
    first: $first
    offset: $offset
    orderBy: SPECIAL_NAME_ASC
    condition: $condition
    filter: $filter
  ) {
    specialsLiabilities: nodes {
      betsCount
      operatorId
      pnl
      specialId
      specialName
      volume
      specialMarket {
        sportIds
        resultedAfter
        competitions {
          nodes {
            competitionId
            competitionName
          }
        }
      }
    }
    totalCount
  }
}
